import apiClient, {
  normalizeArray,
  toApiError,
  withLoading,
} from "./api/client";

export { normalizeArray, toApiError, withLoading };
export default apiClient;
